import { render, staticRenderFns } from "./CardListaSoftware.vue?vue&type=template&id=a0b13da6&scoped=true&"
import script from "./CardListaSoftware.vue?vue&type=script&lang=js&"
export * from "./CardListaSoftware.vue?vue&type=script&lang=js&"
import style0 from "./CardListaSoftware.vue?vue&type=style&index=0&id=a0b13da6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b13da6",
  null
  
)

export default component.exports